function initMap() {
  let curr_data = document.getElementById("js-get-curr-selected"),
  lat = curr_data.dataset.lat,
  long = curr_data.dataset["long"],
  stylesArray = [{
      elementType: "geometry",
      stylers: [{
        color: "#f5f5f5"
      }]
    }, {
      elementType: "labels.icon",
      stylers: [{
        visibility: "off"
      }]
    }, {
      elementType: "labels.text.fill",
      stylers: [{
        color: "#616161"
      }]
    }, {
      elementType: "labels.text.stroke",
      stylers: [{
        color: "#f5f5f5"
      }]
    }, {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{
        color: "#bdbdbd"
      }]
    }, {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{
        color: "#eeeeee"
      }]
    }, {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{
        color: "#757575"
      }]
    }, {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{
        color: "#e5e5e5"
      }]
    }, {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{
        color: "#9e9e9e"
      }]
    }, {
      featureType: "road",
      elementType: "geometry",
      stylers: [{
        color: "#ffffff"
      }]
    }, {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{
        color: "#757575"
      }]
    }, {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{
        color: "#dadada"
      }]
    }, {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{
        color: "#616161"
      }]
    }, {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{
        color: "#9e9e9e"
      }]
    }, {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [{
        color: "#e5e5e5"
      }]
    }, {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [{
        color: "#eeeeee"
      }]
    }, {
      featureType: "water",
      elementType: "geometry",
      stylers: [{
        color: "#c9c9c9"
      }]
    }, {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{
        color: "#9e9e9e"
      }]
    }];
  map = new google.maps.Map(document.getElementById("map"), {
    center: {
      lat: parseFloat(lat),
      lng: parseFloat(long)
    },
    fullscreenControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    styles: stylesArray,
    zoom: 12,
    zoomControl: true,
  });
  let stores = (new google.maps.LatLng(parseFloat(lat), parseFloat(long)),
  new google.maps.Marker({
    map: map,
    icon: current_marker,
    position: {
      lat: parseFloat(lat),
      lng: parseFloat(long)
    }
  }), document.getElementsByClassName("stores__list-item"));
  createMarkers(map, stores);
  getLocation();
  set_list_distance();
}

function randomIntFromInterval(min, max) { // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min)
}

function createMarkers(map, stores) {
  let curr_data = document.getElementById("js-get-curr-selected");
  for (let i = 0; i < stores.length; i++) {
    let store = stores[i],
        lat = store.dataset.lat,
        long = store.dataset["long"],
        mk1 = {position: {lng: curr_data.dataset["long"], lat: curr_data.dataset.lat}},
        mk2 = {position: {lng: long, lat: lat}};
    distance = haversine_distance(mk1, mk2);
    store.setAttribute("data-distance", distance.toFixed(2));
    document.querySelector(`#store_${store.dataset.storeid} .search-mapa-distance`).textContent = `${distance.toFixed(2)} Km`;
    marker = (new google.maps.LatLng(parseFloat(lat), parseFloat(long)),
    new google.maps.Marker({
      map: map,
      icon: marker_option,
      position: {
        lat: parseFloat(lat),
        lng: parseFloat(long)
      },
      title: store.dataset.name,
      storeid: store.dataset.storeid,
      distance: distance
    }));
    google.maps.event.addListener(marker, "click", function() {
      let data, curr_data = document.getElementById("js-get-curr-selected"), req, dataStore = {id: $("#store_" + this.storeid).attr("data-storeid"), title: $("#store_" + this.storeid).attr("data-title"), distance: $("#store_" + this.storeid).attr("data-distance"), address: $("#store_" + this.storeid).attr("data-address"), imagen: $("#store_" + this.storeid).attr("data-imagen"), google_maps: $("#store_" + this.storeid).attr("data-google-maps"), horario: $("#store_" + this.storeid).attr("data-horario"), fono: $("#store_" + this.storeid).attr("data-fono"), info: $("#store_" + this.storeid).attr("data-info"), lat: $("#store_" + this.storeid).attr("data-lat"), long: $("#store_" + this.storeid).attr("data-long")};
      let random_img = dataStore.imagen;
      if (dataStore.imagen == "") {
        random_img = fotos_genericas[randomIntFromInterval(0, fotos_genericas.length - 1)];
        $(this).attr("data-imagen", random_img);
      }
      let store_details_html = `<div class="map-sodastream-container map-panel-container-stores-details" id="store-info-modal" style="display: block;">
          <!-- <div class='soda-store-img' style='background-image: url(${dataStore.imagen});'></div> -->
          <!-- <img class="img-responsive imagen-store" src="${dataStore.imagen}" alt="${dataStore.title}" width="419" height="199" loading="lazy"> -->
          <img class="img-responsive imagen-store" src="${random_img}" alt="${dataStore.title}" width="419" height="199" loading="lazy">
          <div class="map-panel-stores-details">
            <h4>
              <!-- <div>${dataStore.address}</div> -->
              <div>${dataStore.title} <div class='search-mapa-distance mt20 mb20'>${dataStore.distance} Km</div></div>
              <a class="google-maps-store" href="${dataStore.google_maps}" target="_blank">
                <img src="${directions}" alt="Maps Direction" width="64" height="53" loading="lazy">
              </a>
            </h4>
            <div class="map-panel-stores-info">
              <p class="mb0">Horario de atención:</p>
              <p class="mb0 horario-store">${dataStore.address}</p>
              <br>
              <p class="mb0">Horario de atención:</p>
              <p class="mb0 horario-store">${dataStore.horario}</p>
              <br>
              <p class="mb0">Teléfono:</p>
              <p class="mb0 fono-store">${dataStore.fono}</p>
              <br>
              <p class="info-store">${dataStore.info}</p>
            </div>
          </div>
          <a aria-label="Cerrar información " class="trigger-close js-close-store-det" href="#" tabindex="1"></a>
        </div>`;
      map.panTo({
        lat: parseFloat(dataStore.lat),
        lng: parseFloat(dataStore.long)
      });
      map.setZoom(15);
      if ($(window).width() > 767 ) {
        map.panBy(-60, 0);
      } else {
        map.panBy(0, -60);
      }
      $(".map-sodastream-container").hide();
      let mediaQuery = window.matchMedia("(max-width: 991px)");
      if (mediaQuery.matches) {
        $(".map-panel-container-stores-details").remove();
        $("#store-info-modal");
        setTimeout(function() {
          $("#store-info-modal").addClass("fade");
          $("#store-info-modal").removeClass("fade");
          $("#store-info-modal").removeClass("map-sodastream-container");
          $("#store-info-modal").addClass("position-relative");
        }, 1);
        $(".map-sodastream-container").show();
        $(".store-tab-info-container").hide();
      }
      $("#map").after(store_details_html);
      $(".js-close-store-det").on("click", function() {
        console.log("Enc1");
        $(".map-panel-container-stores-details").remove();
        $(".map-sodastream-container").show();
        $(".store-tab-info-container").show();
        map.setZoom(12);
      });
    });
  }
}

function getLocation() {
  navigator.geolocation ? navigator.geolocation.getCurrentPosition(showPosition) : alert("Geolocation is not supported by this browser.")
}

function showPosition(position) {
  var lat = position.coords.latitude;
  var lng = position.coords.longitude;

  const latlng = {
    lat: parseFloat(lat),
    lng: parseFloat(lng)
  };

  let curr_data = document.getElementById("js-get-curr-selected");
  curr_data.dataset.lat = lat;
  curr_data.dataset.long = lng;

  new google.maps.Marker({
    map: map,
    icon: current_marker,
    position: {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    }
  })

  map.panTo({
    lat: parseFloat(lat),
    lng: parseFloat(lng)
  });
  map.setZoom(15);

  const geocoder = new google.maps.Geocoder();
  geocoder
    .geocode({ location: latlng })
    .then((response) => {
      if (response.results[0]) {
        $("#searchStore, #searchStoreRecambio, #searchStoreRetirar, #searchStoreTwo, #searchStoreRecambioTwo, #searchStoreRetirarTwo").val(response.results[0].formatted_address);
      } else {
        window.alert("No results found");
      }
    })
    .catch((e) => window.alert("Geocoder failed due to: " + e));

  set_list_distance();
}

function haversine_distance(mk1, mk2) {
  var R = 3958.8; // Radius of the Earth in miles
  var rlat1 = mk1.position.lat * (Math.PI/180); // Convert degrees to radians
  var rlat2 = mk2.position.lat * (Math.PI/180); // Convert degrees to radians
  var difflat = rlat2-rlat1; // Radian difference (latitudes)
  var difflon = (mk2.position.lng-mk1.position.lng) * (Math.PI/180); // Radian difference (longitudes)

  var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
  return d;
}

function set_list_distance() {
  let list_stores = document.getElementsByClassName("stores__list-item"),
      curr_data = document.getElementById("js-get-curr-selected");
  for (let i = 0; i < list_stores.length; i++) {
    let mk1 = {position: {lng: curr_data.dataset.long, lat: curr_data.dataset.lat}},
        mk2 = {position: {lng: list_stores[i].dataset.long, lat: list_stores[i].dataset.lat}},
        distance = haversine_distance(mk1, mk2);
    list_stores[i].setAttribute("data-distance", distance.toFixed(2));
    let colstore = Array.from(document.querySelectorAll(`#store_${list_stores[i].dataset.storeid} .search-mapa-distance`));
    colstore.map((col)=>{
      col.textContent = `${distance.toFixed(2)} Km`;
    });
  }
  let cols = Array.from(document.querySelectorAll(".stores__list-item"));
  cols.map((col)=>{
    let index = parseInt(col.dataset.distance.replace(".", ""));
    col.style.order = index;
  });
}

let searchInputTwo       = "searchStoreTwo",
  searchInputRecambioTwo = "searchStoreRecambioTwo",
  searchInputRetirarTwo  = "searchStoreRetirarTwo",
  map;

  jQuery.Deferred(function () {
  $(document).ready(function() {
    let autocompleteTwo;
    jQuery.Deferred(function () {
      autocompleteTwo = new google.maps.places.Autocomplete(document.getElementById(searchInputTwo), {
        types: ["geocode"],
        componentRestrictions: {
          country: "ARG"
        }
      });
      google.maps.event.addListener(autocompleteTwo, "place_changed", function() {
        let near_place = autocompleteTwo.getPlace();
        document.getElementById("loc_lat").value = near_place.geometry.location.lat();
        document.getElementById("loc_long").value = near_place.geometry.location.lng();
        $("#js-get-curr-selected").attr("data-lat", near_place.geometry.location.lat());
        $("#js-get-curr-selected").attr("data-long", near_place.geometry.location.lng());
        set_list_distance();
        map.panTo({
          lat: parseFloat(near_place.geometry.location.lat()),
          lng: parseFloat(near_place.geometry.location.lng())
        });
        map.setZoom(15);
        if ($(window).width() > 767 ) {
          map.panBy(-60, 0);
        } else {
          map.panBy(0, -60);
        }
        $(".js-store-detail").on("click", function() {
          let dataStore = {id: $(this).attr("data-storeid"), title: $(this).attr("data-title"), address: $(this).attr("data-address"), distance: $(this).attr("data-distance"), imagen: $(this).attr("data-imagen"), google_maps: $(this).attr("data-google-maps"), horario: $(this).attr("data-horario"), fono: $(this).attr("data-fono"), info: $(this).attr("data-info"), lat: $(this).attr("data-lat"), long: $(this).attr("data-long")};
          let random_img = dataStore.imagen;
          if (dataStore.imagen == "") {
            random_img = fotos_genericas[randomIntFromInterval(0, fotos_genericas.length - 1)];
            $(this).attr("data-imagen", random_img);
          }
          let store_details_html = `<div class="map-sodastream-container map-panel-container-stores-details" id="store-info-modal" style="display: block;">
              <!-- <div class='soda-store-img' style='background-image: url(${dataStore.imagen});'></div> -->
              <!-- <img class="img-responsive imagen-store" src="${dataStore.imagen}" alt="${dataStore.title}" width="419" height="199" loading="lazy"> -->
              <img class="img-responsive imagen-store" src="${random_img}" alt="${dataStore.title}" width="419" height="199" loading="lazy">
              <div class="map-panel-stores-details">
                <h4>
                  <!-- <div>${dataStore.address}</div> -->
                  <div>${dataStore.address} <div class='search-mapa-distance mt20 mb20'>${dataStore.distance} Km</div></div>
                  <a class="google-maps-store" href="${dataStore.google_maps}" target="_blank">
                    <img src="${directions}" alt="Maps Direction" width="64" height="53" loading="lazy">
                  </a>
                </h4>
                <div class="map-panel-stores-info">
                  <p class="mb0">Horario de atención:</p>
                  <p class="mb0 horario-store">${dataStore.horario}</p>
                  <br>
                  <p class="mb0">Teléfono:</p>
                  <p class="mb0 fono-store">${dataStore.fono}</p>
                  <br>
                  <p class="info-store">${dataStore.info}</p>
                </div>
              </div>
              <a aria-label="Cerrar información " class="trigger-close js-close-store-det" href="#" tabindex="1"></a>
            </div>`;
          map.panTo({
            lat: parseFloat(dataStore.lat),
            lng: parseFloat(dataStore.long)
          });
          map.setZoom(15);
          if ($(window).width() > 767 ) {
            map.panBy(-60, 0);
          } else {
            map.panBy(0, -60);
          }
          $(".map-sodastream-container").hide();
          let mediaQuery = window.matchMedia("(max-width: 991px)");
          if (mediaQuery.matches) {
            $("#store-info-modal");
            setTimeout(function() {
              $("#store-info-modal").addClass("fade");
              $("#store-info-modal").removeClass("fade");
              $("#store-info-modal").removeClass("map-sodastream-container");
              $("#store-info-modal").addClass("position-relative");
            }, 1);
            $(".map-sodastream-container").hide();
            $(".store-tab-info-container").hide();
          }
          $("#map").after(store_details_html);
          $(".js-close-store-det").on("click", function() {
            console.log("Enc2");
            $(".map-panel-container-stores-details").remove();
            $(".map-sodastream-container").show();
            map.setZoom(12);
          });
        });
      });
      let autocompleteRecambioTwo;
      autocompleteRecambioTwo = new google.maps.places.Autocomplete(document.getElementById(searchInputRecambioTwo), {
        types: ["geocode"],
        componentRestrictions: {
          country: "ARG"
        }
      });
      google.maps.event.addListener(autocompleteRecambioTwo, "place_changed", function() {
        let near_place = autocompleteRecambioTwo.getPlace();
        document.getElementById("loc_lat_recambio").value = near_place.geometry.location.lat();
        document.getElementById("loc_long_recambio").value = near_place.geometry.location.lng();
        $("#js-get-curr-selected").attr("data-lat", near_place.geometry.location.lat());
        $("#js-get-curr-selected").attr("data-long", near_place.geometry.location.lng());
        set_list_distance();
        map.panTo({
          lat: parseFloat(near_place.geometry.location.lat()),
          lng: parseFloat(near_place.geometry.location.lng())
        });
        map.setZoom(15);
        if ($(window).width() > 767 ) {
          map.panBy(-60, 0);
        } else {
          map.panBy(0, -60);
        }
        $(".js-store-detail").on("click", function() {
          let dataStore = {id: $(this).attr("data-storeid"), title: $(this).attr("data-title"), address: $(this).attr("data-address"), distance: $(this).attr("data-distance"), imagen: $(this).attr("data-imagen"), google_maps: $(this).attr("data-google-maps"), horario: $(this).attr("data-horario"), fono: $(this).attr("data-fono"), info: $(this).attr("data-info"), lat: $(this).attr("data-lat"), long: $(this).attr("data-long")};
          let random_img = dataStore.imagen;
          if (dataStore.imagen == "") {
            random_img = fotos_genericas[randomIntFromInterval(0, fotos_genericas.length - 1)];
            $(this).attr("data-imagen", random_img);
          }
          let store_details_html = `<div class="map-sodastream-container map-panel-container-stores-details" id="store-info-modal" style="display: block;">
              <!-- <div class='soda-store-img' style='background-image: url(${dataStore.imagen});'></div> -->
              <!-- <img class="img-responsive imagen-store" src="${dataStore.imagen}" alt="${dataStore.title}" width="419" height="199" loading="lazy"> -->
              <img class="img-responsive imagen-store" src="${random_img}" alt="${dataStore.title}" width="419" height="199" loading="lazy">
              <div class="map-panel-stores-details">
                <h4>
                  <!-- <div>${dataStore.address}</div> -->
                  <div>${dataStore.address} <div class='search-mapa-distance mt20 mb20'>${dataStore.distance} Km</div></div>
                  <a class="google-maps-store" href="${dataStore.google_maps}" target="_blank">
                    <img src="${directions}" alt="Maps Direction" width="64" height="53" loading="lazy">
                  </a>
                </h4>
                <div class="map-panel-stores-info">
                  <p class="mb0">Horario de atención:</p>
                  <p class="mb0 horario-store">${dataStore.horario}</p>
                  <br>
                  <p class="mb0">Teléfono:</p>
                  <p class="mb0 fono-store">${dataStore.fono}</p>
                  <br>
                  <p class="info-store">${dataStore.info}</p>
                </div>
              </div>
              <a aria-label="Cerrar información " class="trigger-close js-close-store-det" href="#" tabindex="1"></a>
            </div>`;
          map.panTo({
            lat: parseFloat(dataStore.lat),
            lng: parseFloat(dataStore.long)
          });
          map.setZoom(15);
          if ($(window).width() > 767 ) {
            map.panBy(-60, 0);
          } else {
            map.panBy(0, -60);
          }
          $(".map-sodastream-container").hide();
          $("#map").after(store_details_html);
          $(".js-close-store-det").on("click", function() {
            console.log("Enc3");
            $(".map-panel-container-stores-details").remove();
            $(".map-sodastream-container").show();
            map.setZoom(12);
          });
        });
      });
      let autocompleteRetirarTwo;
      autocompleteRetirarTwo = new google.maps.places.Autocomplete(document.getElementById(searchInputRetirarTwo), {
        types: ["geocode"],
        componentRestrictions: {
          country: "ARG"
        }
      });
      google.maps.event.addListener(autocompleteRetirarTwo, "place_changed", function() {
        let near_place = autocompleteRetirarTwo.getPlace();
        document.getElementById("loc_lat_retirar").value = near_place.geometry.location.lat();
        document.getElementById("loc_long_retirar").value = near_place.geometry.location.lng();
        $("#js-get-curr-selected").attr("data-lat", near_place.geometry.location.lat());
        $("#js-get-curr-selected").attr("data-long", near_place.geometry.location.lng());
        set_list_distance();
        map.panTo({
          lat: parseFloat(near_place.geometry.location.lat()),
          lng: parseFloat(near_place.geometry.location.lng())
        });
        map.setZoom(15);
        if ($(window).width() > 767 ) {
          map.panBy(-60, 0);
        } else {
          map.panBy(0, -60);
        }
        $(".js-store-detail").on("click", function() {
          let dataStore = {id: $(this).attr("data-storeid"), title: $(this).attr("data-title"), address: $(this).attr("data-address"), distance: $(this).attr("data-distance"), imagen: $(this).attr("data-imagen"), google_maps: $(this).attr("data-google-maps"), horario: $(this).attr("data-horario"), fono: $(this).attr("data-fono"), info: $(this).attr("data-info"), lat: $(this).attr("data-lat"), long: $(this).attr("data-long")};
          let random_img = dataStore.imagen;
          if (dataStore.imagen == "") {
            random_img = fotos_genericas[randomIntFromInterval(0, fotos_genericas.length - 1)];
            $(this).attr("data-imagen", random_img);
          }
          let store_details_html = `<div class="map-sodastream-container map-panel-container-stores-details" id="store-info-modal" style="display: block;">
              <!-- <div class='soda-store-img' style='background-image: url(${dataStore.imagen});'></div> -->
              <!-- <img class="img-responsive imagen-store" src="${dataStore.imagen}" alt="${dataStore.title}" width="419" height="199" loading="lazy"> -->
              <img class="img-responsive imagen-store" src="${random_img}" alt="${dataStore.title}" width="419" height="199" loading="lazy">
              <div class="map-panel-stores-details">
                <h4>
                  <!-- <div>${dataStore.address}</div> -->
                  <div>${dataStore.address} <div class='search-mapa-distance mt20 mb20'>${dataStore.distance} Km</div></div>
                  <a class="google-maps-store" href="${dataStore.google_maps}" target="_blank">
                    <img src="${directions}" alt="Maps Direction" width="64" height="53" loading="lazy">
                  </a>
                </h4>
                <div class="map-panel-stores-info">
                  <p class="mb0">Horario de atención:</p>
                  <p class="mb0 horario-store">${dataStore.horario}</p>
                  <br>
                  <p class="mb0">Teléfono:</p>
                  <p class="mb0 fono-store">${dataStore.fono}</p>
                  <br>
                  <p class="info-store">${dataStore.info}</p>
                </div>
              </div>
              <a aria-label="Cerrar información " class="trigger-close js-close-store-det" href="#" tabindex="1"></a>
            </div>`;
          map.panTo({
            lat: parseFloat(dataStore.lat),
            lng: parseFloat(dataStore.long)
          });
          map.setZoom(15);
          if ($(window).width() > 767 ) {
            map.panBy(-60, 0);
          } else {
            map.panBy(0, -60);
          }
          $(".map-sodastream-container").hide();
          $("#map").after(store_details_html);
          $(".js-close-store-det").on("click", function() {
            console.log("Enc4");
            $(".map-panel-container-stores-details").remove();
            $(".map-sodastream-container").show();
            map.setZoom(12);
          });
        });
      });
      $(".js-target-curr-pos, .map-target-btn").on("click", function(e) {
        getLocation();
      });
      $(".js-store-detail").on("click", function() {
        let dataStore = {id: $(this).attr("data-storeid"), title: $(this).attr("data-title"), address: $(this).attr("data-address"), distance: $(this).attr("data-distance"), imagen: $(this).attr("data-imagen"), google_maps: $(this).attr("data-google-maps"), horario: $(this).attr("data-horario"), fono: $(this).attr("data-fono"), info: $(this).attr("data-info"), lat: $(this).attr("data-lat"), long: $(this).attr("data-long")};
        console.log("Det1");
        let random_img = dataStore.imagen;
        if (dataStore.imagen == "") {
          random_img = fotos_genericas[randomIntFromInterval(0, fotos_genericas.length - 1)];
          $(this).attr("data-imagen", random_img);
        }
        let store_details_html = `<div class="map-sodastream-container map-panel-container-stores-details" id="store-info-modal" style="display: block;">
            <!-- <div class='soda-store-img' style='background-image: url(${dataStore.imagen});'></div> -->
            <!-- <img class="img-responsive imagen-store" src="${dataStore.imagen}" alt="${dataStore.title}" width="419" height="199" loading="lazy"> -->
            <img class="img-responsive imagen-store" src="${random_img}" alt="${dataStore.title}" width="419" height="199" loading="lazy">
            <div class="map-panel-stores-details">
              <h4>
                <!-- <div>${dataStore.address}</div> -->
                <div>${dataStore.address} <div class='search-mapa-distance mt20 mb20'>${dataStore.distance} Km</div></div>
                <a class="google-maps-store" href="${dataStore.google_maps}" target="_blank">
                  <img src="${directions}" alt="Maps Direction" width="64" height="53" loading="lazy">
                </a>
              </h4>
              <div class="map-panel-stores-info">
                <p class="mb0">Horario de atención:</p>
                <p class="mb0 horario-store">${dataStore.horario}</p>
                <br>
                <p class="mb0">Teléfono:</p>
                <p class="mb0 fono-store">${dataStore.fono}</p>
                <br>
                <p class="info-store">${dataStore.info}</p>
              </div>
            </div>
            <a aria-label="Cerrar información " class="trigger-close js-close-store-det" href="#" tabindex="1"></a>
          </div>`;
        map.panTo({
          lat: parseFloat(dataStore.lat),
          lng: parseFloat(dataStore.long)
        });
        map.setZoom(15);
        if ($(window).width() > 767 ) {
          map.panBy(-60, 0);
        } else {
          map.panBy(0, -60);
        }
        $(".map-sodastream-container").hide();
        let mediaQuery = window.matchMedia("(max-width: 991px)");
        if (mediaQuery.matches) {
          $("#store-info-modal");
          setTimeout(function() {
            $("#store-info-modal").addClass("fade");
            $("#store-info-modal").removeClass("fade");
            $("#store-info-modal").removeClass("map-sodastream-container");
            $("#store-info-modal").addClass("position-relative");
          }, 1);
          $(".map-sodastream-container").show();
          $(".store-tab-info-container").hide();
        }
        $("#map").after(store_details_html);
        $(".js-close-store-det").on("click", function() {
          console.log("Enc1");
          $(".map-panel-container-stores-details").remove();
          $(".map-sodastream-container").show();
          $(".store-tab-info-container").show();
          map.setZoom(12);
        })
      })
    }, 3);
  }), $(".js-map-reset-btn").click(function() {
    $("#searchStore, #searchStoreRecambio, #searchStoreRetirar, #searchStoreTwo, #searchStoreRecambioTwo, #searchStoreRetirarTwo").val("");
  });
}, 0);


